import React from 'react';
import ReactDOM from 'react-dom';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
class BodyLayer extends React.Component {
  constructor(props) {
    super(props);
    // XXX This will have to be guarded if we ever use server side rendering
    this.el = document.createElement('div');
    this.el.className = '_BodyLayer';
    document.body.appendChild(this.el);
  }
  componentWillUnmount() {
    document.body.removeChild(this.el);
  }
  render() {
    return /*#__PURE__*/ReactDOM.createPortal(_jsx("div", {
      ...this.props
    }), this.el);
  }
}
export default BodyLayer;